import React, { useEffect } from 'react';
import styled from 'styled-components';

const AYANAMSA_OPTIONS = [
  { value: 'lahiri', label: 'Lahiri (Chitrapaksha)' },
  { value: 'kp', label: 'Krishnamurti (KP)' },
  { value: 'raman', label: 'B.V. Raman' },
  { value: 'true_chitra', label: 'True Chitrapaksha' },
];

const Wrapper = styled.span`
  display: block;
  width: 100%;
`;

const Select = styled.select`
  padding: 10px 12px;
  border: 1px solid ${p => p.theme.colors.border};
  border-radius: ${p => p.theme.radius.md}px;
  font-size: ${p => p.theme.typography.sizes.md};
  background: ${p => p.theme.colors.surface};
  color: ${p => p.theme.colors.text.primary};
  cursor: pointer;
  width: 100%;
  &:focus { border-color: ${p => p.theme.colors.primary}; outline: none; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const AyanamsaSelector = ({
  value,
  onChange,
  disabled = false,
  disabledReason,
  lang,
  storageKey = 'vedic_panchangam_ayanamsa',
}) => {
  useEffect(() => {
    const stored = localStorage.getItem(storageKey);
    if (stored && stored !== value) {
      onChange(stored);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (e) => {
    const newValue = e.target.value;
    localStorage.setItem(storageKey, newValue);
    onChange(newValue);
  };

  return (
    <Wrapper title={disabled && disabledReason ? disabledReason : undefined}>
      <Select value={value} onChange={handleChange} disabled={disabled}>
        {AYANAMSA_OPTIONS.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </Select>
    </Wrapper>
  );
};

export default AyanamsaSelector;
